import t from "@constants/localization";
import { colors } from "@constants/theme";

import React from "react";
import { StyleSheet, Switch, Text, View } from "react-native";

const MyOrderSwitch = ({ toggleSwitch = () => {}, isEnabled = false }) => {
  const PATH =
    "screens/MyDeliveries/SortingDeliveries/components/MyOrderSwitch";
  return (
    <View style={styles.switchContainer}>
      <Text style={styles.switchText}>{t(`${PATH}/myOrder`)}</Text>
      <Switch
        trackColor={{ false: colors.darkGrey, true: colors.primary }}
        thumbColor={colors.white}
        onValueChange={toggleSwitch}
        value={isEnabled}
        ios_backgroundColor={colors.darkGrey}
        style={{ transform: [{ scaleX: 1 }, { scaleY: 0.9 }] }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  switchContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  switchText: {
    color: colors.mediumBlacklightBlack,
    fontWeight: "700",
  },
});

export default MyOrderSwitch;
